function CarrierModal(el) {
    this.el = el;

    this.innerEl = this.el.querySelector('.jsCarrierModalInner');
    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    this.el.addEventListener('click', e => {
        this.setHideCookie();
        if (e.target.classList.contains('jsCloseModal')) this.hide();
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });

    window.addEventListener('keydown', e => {
        const tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}

CarrierModal.prototype.show = function() {
    return;

    if (this.el.classList.contains('show')) return;

    // Animation
    gsap.timeline()
        .set(this.el, { display: 'flex', opacity: 0 })
        .set(this.innerEl, { y: 20, opacity: 0 })

        .to(this.el, { duration: 0.5, y: 0, opacity: 1, ease: 'power2.inOut' })
        .to(this.innerEl, { duration: 0.5, y: 0, opacity: 1, ease: 'power2.inOut' }, '-=0.5')
        
        .add(_ => {
            this.el.classList.add('show');

            // Set focus to the button element
            setTimeout(_ => this.el.querySelector('.jsCarrierModalBtn').focus(), 200);
        })
        .set(this.el, { clearProps: 'all' })
    ;

    // Prevent overflow on the HTML and body
    document.documentElement.classList.add('no-overflow');
    document.body.classList.add('no-overflow');

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    this.firstFocusableEl.focus();
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
};

CarrierModal.prototype.hide = function() {
    this.setHideCookie();

    // Animation
    gsap.timeline()
        .to(this.el, 0.5, { opacity: 0, ease: 'power2.inOut' })
        .to(this.innerEl, { y: 20, opacity: 0, ease: 'power2.inOut' }, '-=0.5')

        .add(_ => {
            this.el.classList.remove('show');
            if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
            this.focusedElBeforeOpen = null;
        })
        .set(this.el, { clearProps: 'all' })
    ;

    document.documentElement.classList.remove('no-overflow');
    document.body.classList.remove('no-overflow');

    // Accessibility stuff
    if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;
};

CarrierModal.prototype.setHideCookie = function() {
    const cookieName = 'functional_carrier_modal_hide';
    const cookieValue = 'true';
    const date = new Date();

    date.setDate(date.getDate() + 1);

    document.cookie = cookieName + '=' + cookieValue + ';expires=' + date + ';path=/';
};

CarrierModal.prototype.getCookie = function(name) {
    const dc = document.cookie;
    const prefix = name + '=';
    let end = '';
    let begin = dc.indexOf('; ' + prefix);

    if (begin === -1) {
        begin = dc.indexOf(prefix);
        if (begin !== 0) return null;
    }
    else {
        begin += 2;
        end = document.cookie.indexOf(";", begin);

        if (end === -1) end = dc.length;
    }

    return decodeURI(dc.substring(begin + prefix.length, end));
};

(function() {
    const carrierModalEl = document.querySelector('.jsCarrierModal');
    if (carrierModalEl) {
        const carrierModal = new CarrierModal(carrierModalEl);
        if (carrierModal.getCookie('functional_carrier_modal_hide') === null) carrierModal.show();
    }
})();